/* import __COLOCATED_TEMPLATE__ from './default-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();